import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Heading, Image } from '@wix/design-system';
import s from './Enterprise.scss';
import vevo from '../../../assets/images/enterprise/brand-vevo.svg?url';
import kroger from '../../../assets/images/enterprise/brand-kroger.svg?url';
import bolt from '../../../assets/images/enterprise/brand-bolt.svg?url';
import intuit from '../../../assets/images/enterprise/brand-intuit.svg?url';
import glassdoor from '../../../assets/images/enterprise/brand-glassdoor.svg?url';

export const EnterpriseBanner: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className={s.bannerContainer}>
      <Heading className={s.bannerTitle} appearance='H3'>
        {t('enterprise_plans.social_proof.header')}
      </Heading>
      <div className={s.bannerBrands}>
        {EnterpriseBannerItemsData.map(EnterpriseBannerItem)}
      </div>
    </div>
  );
};

const EnterpriseBannerItemsData: string[] = [
  vevo,
  kroger,
  bolt,
  intuit,
  glassdoor,
];

const EnterpriseBannerItem: React.FC<string> = (brand) => {
  return (
    <div key={brand} className={s.brand}>
      <Image src={brand} transparent={true} />
    </div>
  );
};
